/**
 * Lookup tables for the E2 info cards. Copy lives in the locale files; these
 * only map payload values onto translation-key suffixes.
 */

/**
 * BE SHAP display label -> `neat.e2.info.whatGuides.terms.*` key suffix.
 * Mirrors the insights-api allow-list `SHAP_FEATURE_LABELS` (e2_schedule.py);
 * a label missing here simply gets no definition line.
 */
export const SHAP_TERM_KEYS: Record<string, string> = {
  Temperature: "temperature",
  Occupancy: "occupancy",
  "Cooling demand vs. setpoint": "coolingDemand",
  "Heating demand vs. setpoint": "heatingDemand",
  "Time of day": "timeOfDay",
  "Day of week": "dayOfWeek",
  "Weekday vs. weekend": "weekdayWeekend",
  "Cooling degree-days": "coolingDegreeDays",
  "Heating degree-days": "heatingDegreeDays",
  "Solar / daylight": "solar",
  Season: "season",
}

/**
 * E2 end-use bucket -> `neat.e2.info.enduseSources.sources.*` key suffix.
 * Mirrors insights-api `ENDUSES` (e2_schedule.py). Base loads (plugs, water
 * heating, refrigeration, exterior lighting) are not E2 buckets.
 */
export const ENDUSE_SOURCE_KEYS: Record<string, string> = {
  cooling: "cooling",
  heating: "heating",
  fans: "fans",
  pumps: "pumps",
  heat_rejection: "heatRejection",
  heat_recovery: "heatRecovery",
  interior_lighting: "interiorLighting",
}

/** Driver end-uses arrive as `cooling` from the BE; tolerate `cooling_kw` too. */
export const normalizeEnduse = (enduse: string): string =>
  enduse.replace(/_kw$/, "")
